const TEXT = {
   REWARD_CONTENT_TEXT_1:"奖励",
   REWARD_CONTENT_TEXT_2:"年",
   REWARD_CONTENT_TEXT_3:"月",
   REWARD_CONTENT_TEXT_4:"获得总奖励",
   REWARD_CONTENT_TEXT_5:"给出总奖励",
};
export {
	TEXT
}


// WEBPACK FOOTER //
// ./src/config/page/cn/reward/index.js